import * as React from "react";

import {
  DEFAULT_RENDER_OPTIONS,
  DEFAULT_TIMESTAMP_FORMAT,
  formatTimestamp,
} from "./timestampFormat";
import { useTimestampFormat } from "./TimestampFormatContext";

/**
 * Renders an epoch-ns instant as the reader has asked to see it: their format,
 * their precision, their t=0.
 *
 * The single place the "no provider means the built-in defaults" fallback
 * lives. Timestamps render well outside an AI thread, so every renderer needs
 * that fallback and none of them should spell it out again.
 */
export function useFormatTimestamp(): (ns: bigint) => string {
  const ctx = useTimestampFormat();
  const format = ctx?.displayFormat ?? DEFAULT_TIMESTAMP_FORMAT;
  const renderOptions = ctx?.renderOptions ?? DEFAULT_RENDER_OPTIONS;
  return React.useCallback(
    (ns: bigint) => formatTimestamp(ns, format, renderOptions),
    [format, renderOptions],
  );
}
